export default __webpack_public_path__ + "static/rizespor-logo-de95774c2f72065ec104b9122fbdd67a.png";